import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDeterminantTypes.success: {
            return action.payload;
        }

        case constants.clearDeterminantTypes.toString(): {
            return initialState;
        }

        default:
            return state;
    }
}
